/**
 * Narrow chrome.storage.local surface used by the extension UI (no dependency on @types/chrome).
 */
export type ChromeStorageLocalSubset = {
  get(keys: string | string[] | null): Promise<Record<string, unknown>>;
  set(items: Record<string, unknown>): Promise<void>;
  remove(keys: string | string[]): Promise<void>;
};

export function getChromeStorageLocal(): ChromeStorageLocalSubset | undefined {
  const g = globalThis as typeof globalThis & {
    chrome?: { storage?: { local?: ChromeStorageLocalSubset } };
  };
  return g.chrome?.storage?.local;
}
